// extracted by mini-css-extract-plugin
export default {"share":"ShareButton_share__j2JJk"};